"use client";

import React from "react";
import type { TabContentProps } from "@/components/shared/UniversalDetailPage/types/detailPage";
import type { Ticket } from "@/lib/types/database";
import { TicketAISummary } from "../TicketAISummary";
import { TicketDescription } from "../TicketDescription";
import { TicketTimeEntries } from "../TicketTimeEntries";
import { TicketNotes } from "../TicketNotes";

/**
 * Ticket Details Tab Component (centerpiece)
 *
 * Leads with the on-demand AI briefing so a triaging user can get up to speed in
 * one click, then the description (the core "what is this ticket about"), then
 * the work record (time entries) and notes. High-level metadata (status,
 * priority, SLA, client, time totals) now lives in the sidebar glance panel —
 * see useTicketDetailModalTabs.renderInlineInfoPanel.
 */
export const TicketDetailsTab = React.memo(({ item }: TabContentProps<Ticket>) => {
  if (!item) {
    return <div className="text-sm text-gray-500">Loading ticket details...</div>;
  }

  return (
    <div className="w-full space-y-6 pr-1">
      <TicketAISummary ticketId={item.id} />
      <TicketDescription ticket={item} />
      <TicketTimeEntries ticket={item} />
      <TicketNotes ticket={item} />
    </div>
  );
});

TicketDetailsTab.displayName = "TicketDetailsTab";
